import { render } from "./StudentTeacherView.vue?vue&type=template&id=304375e0&scoped=true"
import script from "./StudentTeacherView.vue?vue&type=script&lang=js"
export * from "./StudentTeacherView.vue?vue&type=script&lang=js"

import "./StudentTeacherView.vue?vue&type=style&index=0&id=304375e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304375e0"]])

export default __exports__